module.exports = __webpack_public_path__ + "0aa34d125ed9f6a1685a2d1fa2d21d62.svg";